export default __webpack_public_path__ + "static/media/help.8c4d6145.png";